import React from 'react';
import PropTypes from 'prop-types';

const ShoppingBasketIcon = ({ fill }) => (
    <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.2627 5.9014C13.2627 5.9014 9.6709 0.37239 9.6709 0.37239C9.3436 -0.12413 8.6318 -0.12413 8.3127 0.37239C8.3127 0.37239 4.72091 5.9014 4.72091 5.9014C4.72091 5.9014 0.81818 5.9014 0.81818 5.9014C0.36818 5.9014 0 6.2801 0 6.7429C0 6.8187 0.0081799 6.8944 0.0327301 6.9702C0.0327301 6.9702 2.11091 14.7713 2.11091 14.7713C2.29909 15.4782 2.92909 16 3.68182 16C3.68182 16 14.3182 16 14.3182 16C15.0709 16 15.7009 15.4782 15.8973 14.7713C15.8973 14.7713 17.9755 6.9702 17.9755 6.9702C17.9755 6.9702 18 6.7429 18 6.7429C18 6.2801 17.6318 5.9014 17.1818 5.9014C17.1818 5.9014 13.2627 5.9014 13.2627 5.9014ZM9 3C9 3 11 6 11 6L7 6C7 6 9 3 9 3ZM7 11C7 12.1 7.9 13 9 13C10.1 13 11 12.1 11 11C11 9.9 10.1 9 9 9C7.9 9 7 9.9 7 11Z"
            fill={fill}
            fillRule="evenodd"
        />
    </svg>
);

ShoppingBasketIcon.propTypes = {
    fill: PropTypes.string
};

ShoppingBasketIcon.defaultProps = {
    fill: '#1e1e50'
};

export default ShoppingBasketIcon;



// WEBPACK FOOTER //
// ./src/components/icons/ShoppingBasketIcon.js